import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },

  leftSide: {},

  snackbar_container: {
    left: "45%",
    top: "100px",
    position: "fixed",
    zIndex: 100,
  },
  currentReleaseString: {
    fontWeight: "bold",
    margin: "auto",
  },
  mainPage: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "99.5%",
  },

  rightSide: {
    height: "100%",
    minWidth: "420px",
  },

  boldText: {
    fontWeight: 500,
    textDecoration: "underline",
    color: "black",
    cursor: "pointer",
  },

  topPage: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    marginBottom: "24px",
  },

  mobile_topPage: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column-reverse",
    margin: "0px 20px",
  },

  links: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "520px",
    marginTop: "17px",
  },
  item: {
    marginLeft: 20,
  },
  rtlItem: {
    marginRight: 20,
  },
  mobile_links: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "242px",
    marginTop: "32px",
    marginBottom: "20px",
  },

  units_span: {
    margin: "12px",
    fontSize: "16px",
  },

  graph_container: {
    width: "100%",
    marginBottom: "40px",
  },

  radioButton_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: "24px",
  },
  mobile_radioButton_container: {
    marginBottom: "20px",
    margin: "0px 20px",
  },

  greenDescription_container: {
    marginBottom: "24px",
  },
  greenDescription_container_open: {
    marginBottom: "24px",
    width: "100%",
  },

  mobile_greenDescription_container: {
    marginBottom: "24px",
    margin: "0px 20px",
  },
  mobile_greenDescription_container_open: {
    marginBottom: "24px",
    margin: "0px 20px",
    width: "100%",
  },

  warning_container: {
    marginBottom: "24px",
  },

  mobile_warning_container: {
    margin: "0px 20px",
  },
  carbonTools: {
    marginBottom: 24,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
  },

  //--------------------------------Mobile-----------------------------------
  mainPage_mobile: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
  },

  header_mobile: {
    width: "100%",
  },

  wrapperForHeader: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    marginBottom: "24px",
  },
  notDisplay: {
    display: "none",
  },
  //---------------------- Laptop -----------------------

  rightSide_laptop: {
    height: "100vh",
  },
}));

export default useStyles;
